import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {FileCard} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(FileCard, {
            'size': 'default',
            'name': '年度预算汇总.xlsx',
            'byte': 1024 * 1024 * 2.2,
            'src': 'https://example.com/budget.xlsx'
        }),
        _$cc(FileCard, {
            'type': 'file',
            'name': '封面图.png',
            'byte': 1024 * 320,
            'src': 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80'
        })
    ], 4, 'file-card-demo-basic');
};